export function httpRequestInterceptor(config) {
	const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
	const headers = config.headers;
	if (token) {
		headers.common.Authorization = `Bearer ${token}`;
		this.$bus.$emit('is-loading', true);
	} else {
		this.goTo('login');
	}
	return config;
}

export function httpResponseSuccessInterceptor(response) {
	this.$bus.$emit('is-loading', false);
	return response;
}

export function httpResponseInterceptor(error) {
	this.$bus.$emit('is-loading', false);
	const { status } = error.response || {};
	const loginRoute = 'login';
	if (status === 401) {
		if (error.response.data.code === 1008) {
			this.showGenericError('Usuario y/o contraseña incorrecta, vuelva a intentarlo');
		} else if (error.response.data.message === 'USER_WITH_PREVIOUS_CONNECTION') {
			this.showGenericError('Ya existe una sesión activa con el usuario ingresado.');
		} else {
			this.showNotification('Su sesión ha expirado o alguien más ha ingresado con su cuenta.');
			// llamare aqui el logout manual
			const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
			if (token !== undefined && token != null && token !== '') {
				window.localStorage.clear();
				/* this.$httpAcl.post('logout', {}, {
					headers: {
						authorization: `Bearer ${token}`,
					},
				}); */
				window.localStorage.setItem(`${process.env.STORAGE_USER_KEY}::${'date-close-notify-expired-plan'}`, JSON.stringify(null));
				window.localStorage.setItem(`${process.env.STORAGE_USER_KEY}::${'expiration-date'}`, JSON.stringify(null));
				window.localStorage.setItem(`${process.env.STORAGE_USER_KEY}::${'storage-expiration-date'}`, JSON.stringify(null));
				this.goTo(loginRoute);
			}
		}
	} else if (status === 403) {
		this.showNotification('No tiene suficientes permisos para realizar esta acción');
	} else if (status === 500) {
		this.showGenericError();
	}
	return Promise.reject(error.response);
}



// WEBPACK FOOTER //
// ./src/http.js